package ir.site.zero1plus.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import ir.site.zero1plus.components.sections.FooterSection
import ir.site.zero1plus.components.sections.Header
import kotlinx.browser.document

@Composable
fun PageLayout(
    title: String,
    description: String? = null,
    onOverFlowMenuClicked: () -> Unit,
    content: @Composable () -> Unit
) {
    LaunchedEffect(title) {
        document.title = title
    }

    LaunchedEffect(description) {
        val head = document.head!!
        if (description != null) {
            val meta = head.querySelector("meta[name='description']") ?: document.createElement("meta").apply {
                setAttribute("name", "description")
                appendChild(this)
            }
            meta.setAttribute("content", description)
        } else {
            head.querySelector("meta[name='description']")?.let {
                head.removeChild(it)
            }
        }
    }

    Box {
        Column(
            modifier = Modifier
                .fillMaxSize()
        ) {
            Header(onOverFlowMenuClicked = onOverFlowMenuClicked)
            content()
            FooterSection()
        }
    }

}